export default __webpack_public_path__ + "static/silvia-di-nardo-d86e8e11f5399bb801926c44394989a5.png";